// extracted by mini-css-extract-plugin
export default {"root":"checkmark-module--root--ec526","checkmark":"checkmark-module--checkmark--83c94"};